<template>
  <section id="stepper">
    <div class="demo">
      <h5>Vertical</h5>
      <div class="stepper stepper-vertical">
        <div class="stepper-step complete">
          <a class="stepper-dot" href="#"></a>
          <h5 class="stepper-stepnum">Step 1</h5>
          <div class="stepper-info">Lorem ipsum dolor sit amet.</div>
        </div>
        <div class="stepper-step complete">
          <a class="stepper-dot" href="#"></a>
          <h5 class="stepper-stepnum">Step 2</h5>
          <div class="stepper-info">Vestibulum ante ipsum primis in faucibus orci luctus et.
          </div>
        </div>
        <div class="stepper-step active">
          <a class="stepper-dot" href="#"></a>
          <h5 class="stepper-stepnum">Step 3</h5>
          <div class="stepper-info">Ultrices posuere cubilia Curae.</div>
        </div>

        <div class="stepper-step disabled">
          <a class="stepper-dot" href="#"></a>
          <h5 class="stepper-stepnum">Step 4</h5>
          <div class="stepper-info">Duis porta ipsum vitae mi bibendum bibendum.</div>
        </div>
        <div class="stepper-step disabled">
          <a class="stepper-dot" href="#"></a>
          <h5 class="stepper-stepnum">Step 5</h5>
          <div class="stepper-info">Lorem ipsum dolor sit amet.</div>
        </div>
      </div>

      <h5>Horizontal</h5>
      <div class="row stepper">
        <div class="col-4 stepper-step complete">
          <h5 class="text-center stepper-stepnum">Step 1</h5>
          <div class="progress">
            <div class="progress-bar"></div>
          </div>
          <a href="#" class="stepper-dot"></a>
          <div class="stepper-info text-center">Lorem ipsum dolor sit amet.</div>
        </div>

        <div class="col-4 stepper-step active">
          <!-- complete -->
          <h5 class="text-center stepper-stepnum">Step 2</h5>
          <div class="progress">
            <div class="progress-bar"></div>
          </div>
          <a href="#" class="stepper-dot"></a>
          <div class="stepper-info text-center">Integer semper dolor ac auctor rutrum.
          </div>
        </div>

        <div class="col-4 stepper-step disabled">
          <!-- active -->
          <h5 class="text-center stepper-stepnum">Step 3</h5>
          <div class="progress">
            <div class="progress-bar"></div>
          </div>
          <a href="#" class="stepper-dot"></a>
          <div class="stepper-info text-center">
            Curabitur mollis magna at blandit vestibulum.</div>
        </div>
      </div>
    </div>
        <section class="md" v-html="mdfile"></section>
  </section> 
</template>

<script>
import mdfile from "@/docs/components/stepper.md";
export default {
  name: "stepper",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.components.stepper.name);
    this.$emit("update-tagline", this.$root.yamlData.components.stepper.description);
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
